module.exports = __webpack_public_path__ + "static/media/christian-dior-fahrenheit-big.2511eb50.png";